// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tPMG","fullView":"styles_fullView__3xQ7z"};